import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../../assets/logos/thrive.jpg";
import "./Footer.css";

const Footer = ({ className = "" }) => {
  return (
    <footer className={`footer ${className}`}>
      <div className="footer__inner">
        <div className="footer__brand">
          <Link to="/" aria-label="Thrive Holdings home">
            <img src={logo} alt="Thrive Holdings Limited" />
          </Link>
          <p>
            Building customer-focused businesses that help people and
            organisations move forward with confidence.
          </p>
          <div className="footer__socials" aria-label="Social media">
            <a
              href="https://ng.linkedin.com/company/combined-all-risks-insurance-brokers-carib-nigeria-limited"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn aria-hidden="true" />
            </a>
            <a
              href="https://www.instagram.com/thriveinsurancebrokers/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram aria-hidden="true" />
            </a>
            <a
              href="https://www.facebook.com/thriveinsurancebrokers/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="footer__column">
          <h2>Company</h2>
          <Link to="/group">Who we are</Link>
          <Link to="/what-we-do">What we do</Link>
          <Link to="/board-of-directors">Leadership</Link>
          <Link to="/career">Careers</Link>
        </div>

        <div className="footer__column">
          <h2>Our companies</h2>
          <a
            href="https://www.insurance.thrivenig.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Thrive Insurance Brokers Limited
          </a>
          <a
            href="https://www.travels.thrivenig.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Thrive Travels &amp; Tours Limited
          </a>
        </div>

        <div className="footer__column footer__contact">
          <h2>Get in touch</h2>
          <p>
            Western House, 17th Floor, Wing C, 8–10 Broad Street, Lagos Island,
            Lagos.
          </p>
          <a href="tel:+2348180996418">+234 818 099 6418</a>
          <Link to="/contact">Contact our team</Link>
        </div>
      </div>

      <div className="footer__bottom">
        <p>
          &copy; {new Date().getFullYear()} Thrive Holdings Limited. All rights
          reserved.
        </p>
        <div>
          <Link to="/privacy-policy">Privacy</Link>
          <Link to="/terms-and-conditions">Terms</Link>
          <Link to="/cookie-policy">Cookies</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
  